export const getFilteredStateOptionsWithCityAndArea = (
  state,
  cities,
  areas
) => {
  if (areas.length > 0) {
    const areaStates = areas.map(innerArea => {
      const {
        value: [value],
      } = innerArea
      const t = value.match(/(.*) \(((.*) - (.*))\)/)
      const [, , , , selectedState] = t
      return selectedState
    })
    return areaStates.includes(state)
  }

  if (cities.length > 0) {
    const cityStates = cities.map(innerCity => {
      const {
        value: [value],
      } = innerCity
      if (!value || typeof value !== 'string') return null

      const match = value.match(/(.*) - (.*)/) || []
      const [, , selectedState] = match

      return selectedState || ''
    })
    return cityStates.includes(state)
  }

  return true
}
export const getFilteredCityOptionsWithStateAndArea = (city, states, areas) => {
  const [, selectedCity, selectedState] = city.match(/(.*) - (.*)/)

  if (areas.length > 0) {
    const areaStates = areas.map(innerArea => {
      const {
        value: [value],
      } = innerArea
      const t = value.match(/(.*) \(((.*) - (.*))\)/)
      const [, , , selectedState] = t
      return selectedState
    })

    return areaStates.includes(selectedCity)
  }

  return states.length
    ? states.filter(({ value: [value] }) => value === selectedState).length > 0
    : true
}

export const getFilteredAreaOptionsWithStateAndCity = (
  area,
  states,
  cities
) => {
  const [, , selectedCity, , selectedState] = area.match(
    /(.*) \(((.*) - (.*))\)/
  )
  return cities.length
    ? cities.filter(({ value: [value] }) => value === selectedCity).length > 0
    : states.length
    ? states.filter(({ value: [value] }) => value === selectedState).length > 0
    : true
}
